import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "input-group flex-nowrap" }
const _hoisted_2 = { class: "input-group-append" }

import { useI18n } from "vue-i18n";
import { SelectionListModel } from "@medapro-types/AdvancedSearch/components/QueryBuilder";
import Icon from "@common/components/Icon.vue";
import { computed } from "vue";

//#region General

export default /*#__PURE__*/_defineComponent({
  __name: 'EditableDropDownRule',
  props: {
    value: {},
    items: { default: () => [] }
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const { t: $t } = useI18n();



function onClick(name: string) {
  emits("input", name);
}

function clear() {
  emits("input", "");
}
//#endregion

//#region Update localModal
const localModel = computed({
  get() {
    return props.value;
  },
  set(nv) {
    emits("input", nv);
  }
});
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_b_dropdown_item_button = _resolveComponent("b-dropdown-item-button")!
  const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider")!
  const _component_b_dropdown_header = _resolveComponent("b-dropdown-header")!
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      class: "form-control",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localModel).value = $event)),
      "data-cy": "search-txt"
    }, null, 512), [
      [_vModelText, localModel.value]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_b_dropdown, { right: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_b_dropdown_item_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (clear())),
            disabled: !props.value
          }, {
            default: _withCtx(() => [
              _createVNode(Icon, {
                icon: "Broom",
                class: "mr-1"
              }),
              _createTextVNode(" " + _toDisplayString(_unref($t)("Clear")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_b_dropdown_divider),
          _createVNode(_component_b_dropdown_header, { id: "dropdown-header" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($t)("Users")), 1)
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
            return _withDirectives((_openBlock(), _createBlock(_component_b_dropdown_item, {
              key: item.userId,
              onClick: ($event: any) => (onClick(item.name)),
              active: props.value == item.name
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["onClick", "active"])), [
              [
                _directive_b_tooltip,
                item.name,
                void 0,
                {
                  viewport: true,
                  hover: true
                }
              ]
            ])
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})